import { ApolloClient, InMemoryCache, NormalizedCacheObject } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { createUploadLink } from 'apollo-upload-client';

export function CreateApolloClient(token?: string): ApolloClient<NormalizedCacheObject> {
    const uploadLink = createUploadLink({
        uri: `${import.meta.env.VITE_API_SERVICE_URL}/api/graphql`,
        headers: {
            'content-type': 'application/json',
            'apollo-require-preflight': 'true',
        },
    });

    const authLink = setContext((_, { headers }) => {
        // get the authentication token from local storage if it exists
        const bearerToken = token ?? localStorage.getItem('token');

        // return the headers to the context so httpLink can read them
        return {
            headers: {
                ...headers,
                authorization: bearerToken ? `Bearer ${bearerToken}` : '',
                'content-type': 'application/json',
                'apollo-require-preflight': 'true',
            },
        };
    });

    const client = new ApolloClient({
        link: authLink.concat(uploadLink),
        cache: new InMemoryCache(),
    });

    return client;
}
